class LinkedProductsProvider extends HTMLElement {
  constructor() {
    super();

    this.main = {
      title: this.dataset.title,
      handle: this.dataset.product,
    };
    this.$list = this.querySelector(".linked-swatches");

    this.search();
  }

  fetchQuery() {
    return fetch(`/search?q=${this.query}&view=json`).then((res) => res.json());
  }

  hide() {
    this.style.display = "none";
  }

  async search() {
    const result = await this.fetchQuery();

    const siblings = result.results.filter((item) => {
      return item.title.split(" - ")[1] === this.query;
    });

    if (siblings.length === 0) return this.hide();

    const swatchHtml = siblings.reduce(
      (html, item) => (html += this.generateSwatchHtml(item)),
      ""
    );

    this.$list.innerHTML = swatchHtml;

    console.log("LinkedProductsMain: Search Results:", result, { siblings });
  }

  generateSwatchHtml(item) {
    return `
        <li class="linked-swatch ${
          item.handle === this.main.handle ? "active-swatch" : ""
        }" style="background-image: url(${item.featured_image})">
            <a href="${item.url}">
              <img src="${item.featured_image}" alt="${item.title}" />
            </a>
        </li>
    `;
  }

  get query() {
    return this.main.title.split(" - ")[1];
  }
}

customElements.define("linked-products", LinkedProductsProvider);
